/**
 * Filter component creation logic
 */
import { IFilter } from '../../../models';
import { DEFAULT_COEFFICIENTS, SectionCreationContext } from '../../../models/bot';
import { IBotSection } from '../../../models';
import { dispatchMutation } from '../../../utils/dispatch.utils';
import { filterApi } from '../../../services';

/**
 * Creates a filter component for a section
 */
export async function createFilterComponent(
  botSection: IBotSection,
  sectionId: number,
  context: SectionCreationContext,
  modelData: any,
): Promise<IFilter> {
  const { getOptions, onProgress } = context;

  if (!botSection.type_id) {
    throw new Error('Filter type_id is required');
  }

  // Use model data if available (from getFilterModelData)
  const filterModel = modelData?.model;
  const filterFrame = modelData?.frame;

  let filter: IFilter = await dispatchMutation(
    filterApi.endpoints.createFilter,
    {
      body: {
        section_id: sectionId,
        type_id: botSection.type_id,
        merv_id: botSection.merv_id || 8,
        depth_nominal_id: botSection.depth_nominal_id || 2,
        frame_loading_id: botSection.frame_loading_id || 1,
        air_stream_id: botSection.air_stream_id || 1,
        airflow_actual: botSection.airflow,
        has_frame: !!filterFrame,
        size_qty_id: filterModel.size_qty_id,
        // Enhanced: Use model data if available
        ...(filterModel && {
          filter_params: JSON.stringify(filterModel),
          master_filter_id: filterModel.id,
        }),
        ...(filterFrame && {
          frame_params: JSON.stringify(filterFrame),
          master_frame_id: filterFrame.id,
        }),
      },
    },
    getOptions(),
  );
  if (botSection.air_stream_id !== 1) {
    filter = await dispatchMutation(
      filterApi.endpoints.updateFilter,
      {
        body: {
          airflow_actual: botSection.airflow,
        },
        id: filter.id,
      },
      getOptions(),
    );
  }

  onProgress?.(DEFAULT_COEFFICIENTS.filter_create); // filter_create coefficient

  return filter;
}
